import { endpointStore } from "../../utils/mobx/EndpointStore";
import { staticLabelStore } from "../../utils/mobx/StaticLabelStore";

const EndpointTitleMap = {
  "layout-analysis": "LayoutAnalysis",
  ocr: "OCR",
  extractor: "Extractor",
};

export const EndpointTitle = () => {
  const { endpointType } = endpointStore;
  const { staticLabels } = staticLabelStore;

  const headerKey =
    EndpointTitleMap[endpointType as keyof typeof EndpointTitleMap];

  return (
    <div className="large">
      {staticLabels?.Header?.[headerKey]?.[1] && (
        <div className="text-large">{staticLabels.Header[headerKey][0]}</div>
      )}
    </div>
  );
};
